import React from 'react';
import { Box, Typography, IconButton } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

interface PageHeaderProps {
  title: string;
  onBack?: () => void;
  backTo?: string;
  showBackButton?: boolean;
  titleVariant?: 'h3' | 'h4' | 'h5' | 'h6';
  className?: string;
  sx?: any;
  rightAction?: React.ReactNode; // Add support for right-side action buttons
}

export const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  onBack,
  backTo = '/',
  showBackButton = true,
  titleVariant = 'h5',
  className,
  sx = {},
  rightAction
}) => {
  const navigate = useNavigate();

  const handleBack = () => {
    if (onBack) {
      onBack();
    } else {
      navigate(backTo);
    }
  };

  return (
    <Box 
      sx={{ 
        display: 'flex', 
        alignItems: 'center', 
        gap: 2, 
        mb: 3,
        ...sx
      }}
      className={className}
    >
      {showBackButton && (
        <IconButton
          onClick={handleBack}
          sx={{
            color: 'text.primary',
            '&:hover': {
              backgroundColor: 'action.hover'
            }
          }}
          aria-label="Go back"
        >
          <ArrowBack />
        </IconButton>
      )}
      
      <Typography 
        variant={titleVariant} 
        component="h1" 
        sx={{ 
          fontSize: titleVariant === 'h5' ? '1.5rem' : undefined,
          fontWeight: 600,
          flex: 1
        }}
      >
        {title}
      </Typography>
      
      {rightAction && (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          {rightAction}
        </Box>
      )}
    </Box>
  );
};
